import React, { useState, useRef } from "react";
import LeadSubmission from "../components/LeadSubmission";
import FooterButtonHoc from "../../common/FooterButtonHoc";
import { useData } from "../../services/context/DataContext";
import { getBackSteps } from "../../services/utils/utils";
import { SAVE_LEAD_URL } from "../../services/api/apiUrls";
import { postRequest } from "../../services/api/apiService";
import { CONTACT_INFO_INIT } from "../../services/types/LeadRequisitionType";
import { INIT_STEPS } from "../../services/constants/InitialConstants";
import { handleScript } from "../../services/utils/utils";

const LeadSubmissionPage: React.FC = () => {
  const {
    steps,
    setSteps,
    contactInfo,
    companyInfo,
    businessNeedInfo,
    setIsSubmitted,
    setError,
    setIsAboutBusiness,
    setCompanyInfo,
    setContactInfo,
    setIsBasicInfo,
    setBusinessNeedInfo,
    setTextAreaValue,
    setIsCancelClicked,
  } = useData();
  const currentStep = 4;
  const [isLoading, setIsLoading] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);

  const onSubmitHandler = async () => {
    try {
      setTextAreaValue([]);
      setError(null);
      setIsLoading(true);
      const body = {
        currentPage: "Final",
        companyInfo: {
          ...companyInfo,
          headquaterCountry: companyInfo?.headquaterCountry,
        },
        contactInfo,
        businessNeeds: businessNeedInfo?.businessNeeds,
      };
      handleScript(divRef, "ccbContactUsFormComplete");
      setIsSubmitted(true);
      const { data } = await postRequest(SAVE_LEAD_URL, body);
      
      console.log(data, "data");
      // if (data.status === "OK") {
      //   setIsSubmitted(true);
      // } else {
      //   setError("API_FAILED_ERROR");
      // }
      if (window.parent.location.href.includes("contact-us")) window.parent.scrollTo(0, 0);
      
      (window as any)?.parent.lintrk('track', { conversion_id: (window as any)?.frameElement?.attributes.getNamedItem("conversionid")?.value });
    } catch (e) {
      console.log("LOG: ~ Errror in submitting lead");
    } finally {
      setIsLoading(false);
    }
  };

  const onCancelHandler = () => {
    setIsAboutBusiness(false);
    setCompanyInfo(null);
    setContactInfo(CONTACT_INFO_INIT);
    setSteps(INIT_STEPS);
    setBusinessNeedInfo(() => ({ businessNeeds: [] }));
    setIsBasicInfo(false);
    setError(null);
    if (window.parent.location.href.includes("contact-us")) window.scrollTo(0, 0);
    setIsCancelClicked(true);
  };

  const onBackHandler = async () => {
    const newSteps = getBackSteps(steps, currentStep);
    setSteps(newSteps);
    if (window.parent.location.href.includes("contact-us")) window.scrollTo(0, 0);
  };

  return (
    <div>
      <div ref={divRef}></div>
      <LeadSubmission />
      <div>
        <FooterButtonHoc
          id={window?.frameElement?.attributes.getNamedItem("uniqueid")?.value}
          submitText="Submit"
          isLoading={isLoading}
          onBack={onBackHandler}
          onCancel={onCancelHandler}
          onSubmit={onSubmitHandler}
        />
      </div>
    </div>
  );
};

export default LeadSubmissionPage;
